import React from 'react';
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import Header from "../../Layouts/Header";

import API from "../../Services/API";
import {toast} from "react-toastify";
import {useNavigate, useParams} from "react-router-dom";
import {HiOutlineLocationMarker, HiOutlineQrcode} from "react-icons/hi";
import {BsCalendar4Week} from "react-icons/bs";
import {TbCoin, TbStatusChange} from "react-icons/tb";
import {MdOutlinePayment, MdOutlineWorkOutline} from "react-icons/md";
import {CiMoneyBill, CiPercent, CiViewList} from "react-icons/ci";
import {GiTwoCoins} from "react-icons/gi";
import {FaUserGear} from "react-icons/fa6";
import {FaAngleLeft} from "react-icons/fa";
import {GoStarFill} from "react-icons/go";


const currencyFormat = Intl.NumberFormat('en-US');

function Request() {
    const {id} = useParams();
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [request, setRequest] = React.useState([]);
    const [payType, setPayType] = React.useState(0);

    let totalPrice = 0;

    React.useEffect(() => {
        const search = window.location.search;
        const query = new URLSearchParams(search);
        const message = query.get('message')
        if(message) {
            const success = query.get('success')
            success === '1' ? toast.success(message) : toast.error(message)
        }

        const params = {
            'processFor' : 'Customer'
        }

        API.getRequest(params , id)
            .then((response) => {
                setRequest(response.data);

                setTimeout(() => {
                    setIsLoaded(true);
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }, 400)
            })
            .catch((error) => {
                if(error.response) {
                    toast.error(error.response.data.message);
                    window.history.back()
                }
                else {
                    toast.error(error.message);
                    window.history.back()
                }
            });


    }, [id]);

    const onPayClick = () =>{
        if(payType === 21) {
            setIsLoaded(false);
            const params = {
                request_id : id,
                return_url: `https://app.sooraj.ir/requests/${id}`,
                bank_unique_code : 'mellat'
            }
            API.getBankURL(params)
                .then((response) => {
                    toast.success('تا لحظاتی دیگر به درگاه بانک متصل می شوید...')
                    setTimeout (() => {
                        setIsLoaded(true);
                        window.location.assign(`${response.data.paymentURL}&external==true`);
                    },1500)

                })
                .catch((error) => {
                    if(error.response) {
                        toast.error(error.response.data.message);
                    }
                    else {
                        toast.error(error.message);
                    }
                });

        }
        if(payType === 20) {
            setIsLoaded(false);
            const params = {
                request_id : id,
                pay_type: '20',
            }
            API.savePayment(params)
                .then((response) => {
                    toast.success(response.message)
                    setTimeout (() => {
                        const params = {

                        }

                        API.getRequest(params , id)
                            .then((response) => {
                                setRequest(response.data);
                                setIsLoaded(true);
                            })
                            .catch((error) => {
                                if(error.response) {
                                    toast.error(error.response.data.message);
                                }
                                else {
                                    toast.error(error.message);
                                }
                            });
                    },1500)

                })
                .catch((error) => {
                    if(error.response) {
                        toast.error(error.response.data.message);
                        setIsLoaded(true);
                    }
                    else {
                        toast.error(error.message);
                        setIsLoaded(true);
                    }
                });

        }
    }

    const echoStars = (count) => {
        let stars = [];
        for ( let st = 0 ; st < count ; st++) {
            stars.push( <GoStarFill className='text-big-1 mx-2 text-warning' />)
        }
        return stars;
    }
    return (
        <React.Fragment>
            <Toast />
            {
                !isLoaded && <Loading />
            }

            <Header title='مشاهده درخواست' hasBack={true} backAddress='/requests' />

            {
                isLoaded &&
                <section className="container-fluid  mt-3 py-5 rtl px-0   ">
                    <div className="row mx-2 mb-3 border-bottom pb-2">

                        {
                            request.status_id === 6 ?
                                <div className="col-12 mt-3 py-1">
                                    {
                                        request.rate > 0 ?

                                            <div className='text-center py-0'>


                                                {echoStars(request.rate)}
                                            </div>
                                            :
                                            <div className="mb-4 btn btn-primary  w-100 text-small-2 py-2"
                                                 onClick={() => navigate(`/rate/${request.id}`)}
                                            >
                                                هنوز به این درخواست امتیازی نداده اید!
                                                <span  className='text-warning fw-bold float-start'>
                                                            ثبت نظر
                                                            <FaAngleLeft />
                                                        </span>

                                            </div>
                                    }

                                </div>
                                :
                                ''
                        }
                        <div className="col-1">
                            <HiOutlineQrcode />
                        </div>
                        <div className="col-5 text-small-2">
                            شماره قبض
                        </div>
                        <div className="col-6 text-start fw-bold text-small-2">
                            {request.tracking_code}
                        </div>
                    </div>
                    <div className="row mx-2 mb-3 border-bottom pb-2">
                        <div className="col-1">
                            <TbStatusChange />
                        </div>
                        <div className="col-5 text-small-2">
                            وضعیت درخواست
                        </div>
                        <div className="col-6 text-start fw-bold text-small-2" style={{color: request.last_status.color}}>
                            {request.last_status.title}
                        </div>
                    </div>

                    <div className="row mx-2 mb-3  pb-2">
                        <div className="col-1">
                            <BsCalendar4Week />
                        </div>
                        <div className="col-5 text-small-2">
                            تاریخ ثبت درخواست
                        </div>
                        <div className="col-6 text-start fw-bold text-small-2">
                            {request.date}
                        </div>
                    </div>

                    <div className="row mx-2 mb-3  pb-2">
                        <div className="col-1">
                            <BsCalendar4Week />
                        </div>
                        <div className="col-5 text-small-2">
                            تاریخ مراجعه
                        </div>
                        <div className="col-6 text-start fw-bold text-small-2">
                            {request.doing_date}
                            <br/>
                            {request.doing_time}
                        </div>
                    </div>

                    <div className="row mx-2 mb-3  pb-2">
                        <div className="col-1">
                            <FaUserGear />
                        </div>
                        <div className="col-5 text-small-2">
                           خدمت رسان
                        </div>
                        <div className="col-6 text-start fw-bold text-small-2">
                            {request.servitor?.name}
                            &nbsp;
                            {request.servitor?.surname}
                            &nbsp;
                            ( <a className='text-small-1 text-decoration-none' href={`tel:${request.servitor?.username}`}>{request.servitor?.username}</a>)

                        </div>
                    </div>

                    <div className="row mx-2 mb-3 pb-2 custom-card">
                        <div className="col-1">
                            <HiOutlineLocationMarker />
                        </div>
                        <div className="col-7 text-small-2 pt-1">
                            <b>{request.address.title}</b> :&nbsp;
                            {request.address.address}
                        </div>
                        <div className="col-4 text-start fw-bold text-small-2 pt-1">
                            <a href={`geo:${request.address.lat},${request.address.long}`} rel="noreferrer" target='_blank' >مشاهده روی نقشه</a>
                        </div>
                    </div>
                    <div className="row mx-2 mb-3 pb-2 custom-card">
                        <div className="col-1">
                            <MdOutlineWorkOutline />
                        </div>
                        <div className="col-6 text-small-2 pt-1">
                            <b>{request.company.title}</b>
                        </div>
                        <div className="col-5 text-start fw-bold text-small-2 pt-1">
                            <a href={`tel:${request.company.support_phone}`} rel="noreferrer" target='_blank' >{request.company.support_phone}</a>
                        </div>
                    </div>
                    <div className="row mx-2 mb-3 pb-2 custom-card">
                        <div className="col-1 mb-3">
                            <CiViewList />
                        </div>
                        <div className="col-11 text-small-2 fw-bold pt-1 mb-3">
                           فاکتور
                        </div>

                        <div className="col-1 text-small-1 text-center border-bottom py-2">
                            #
                        </div>
                        <div className="col-6 text-small-1 text-center border-bottom py-2">
                            عنوان
                        </div>
                        <div className="col-3 text-small-1 text-center border-bottom py-2">
                            فی (تعداد)
                        </div>
                        <div className="col-2 text-small-1 text-center border-bottom py-2">
                            تعداد
                        </div>

                        {

                            request.details.map((detail,index) => {
                            totalPrice += parseInt(detail.count * detail.service_price);
                                return (
                                    <React.Fragment key={index}>
                                        <div className="col-1 text-small-1 text-center  py-2">
                                            {index + 1}
                                        </div>
                                        <div className="col-6 text-small-1 text-center  py-2 fw-bold">
                                            {detail.service.title}
                                        </div>
                                        <div className="col-3 text-small-1 text-center  py-2">
                                            {currencyFormat.format(detail.service_price)}
                                        </div>
                                        <div className="col-2 text-small-1 text-center  py-2">
                                            {detail.count}
                                        </div>
                                        <div className="col-7 border-bottom pb-3">
                                            &nbsp;
                                        </div>
                                        <div className="col-5 text-start mb-3 text-muted text-small-1 fw-bold border-bottom pb-3">
                                            {currencyFormat.format(detail.count * detail.service_price)}
                                            &nbsp;
                                            ریال
                                        </div>
                                    </React.Fragment>
                                )
                            })


                        }
                        <div className="col-2 mt-3">
                            &nbsp;
                        </div>
                        <div className="col-5 mt-3 text-small-2">
                            <TbCoin className='ms-2' />
                            مبلغ فاکتور
                        </div>
                        <div className="col-5 fw-bold mt-3 text-secondary  text-start">
                            {currencyFormat.format(totalPrice)}
                            &nbsp;
                            ریال
                        </div>
                        <div className="col-2 mt-3">
                            &nbsp;
                        </div>
                        <div className="col-5 mt-3 text-small-2 border-bottom pb-2">
                            <CiPercent className='ms-2' />
                            تخفیف
                        </div>
                        <div className="col-5 fw-bold mt-3 text-success  border-bottom pb-2 text-start">
                            {currencyFormat.format(totalPrice - request.pay_amount)}
                            &nbsp;
                            ریال
                        </div>
                        <div className="col-2 mt-3">
                            &nbsp;
                        </div>
                        <div className="col-5 mt-3 text-small-2">
                            <GiTwoCoins className='ms-2' />
                            مبلغ قابل پرداخت:
                        </div>
                        <div className="col-5 fw-bold mt-3  text-start">
                            {currencyFormat.format(request.pay_amount)}
                            &nbsp;
                            ریال
                        </div>



                    </div>
                    <div className="row mx-2 mb-3  pb-2 custom-card">
                        <div className="col-1">
                            <MdOutlinePayment />
                        </div>
                        <div className="col-6 text-small-2 pt-1">
                            {request.pay_type}
                            {
                                request.pay_time ?
                                request.pay_verified > 0 ?
                                    <span className='badge badge-pill badge-success bg-success mx-1 text-small-3'>
                                                تایید شده
                                            </span>
                                    :
                                    <span className='badge badge-pill badge-danger bg-danger mx-1 text-small-3'>
                                                تایید نشده
                                            </span>
                                    : ''
                            }
                        </div>
                        <div className="col-5 text-start fw-bold text-small-2 pt-1">
                            &nbsp;  {request.pay_time}
                        </div>
                    </div>
                    {
                        ([3,4,5].includes(request.last_status.id )  &&  !request.pay_time) &&
                        <div className="row mx-2 mb-3 pb-2 custom-card">
                            <div className="col-1 mb-1">
                                <CiMoneyBill />
                            </div>
                            <div className="col-11 text-small-2 fw-bold pt-1 mb-1 ">
                                انتخاب روش پرداخت
                            </div>
                            <div className="col-12 mt-3">
                                <div className={payType === 21 ? "card py-2 px-4 bg-success bg-opacity-10" : "card py-2 px-4 "}

                                     onClick={
                                         () => {setPayType(21)}
                                     }

                                >
                                    <span className='fw-bold'>پرداخت آنلاین</span>
                                    <p className='text-small-2 pt-2'>
                                        پرداخت مبلغ
                                        درخواست
                                        از طریق درگاه آنلاین بانک
                                    </p>
                                </div>
                            </div>
                            <div className="col-12 mt-3">
                                <div className={payType === 20 ? "card py-2 px-4 bg-success bg-opacity-10" : "card py-2 px-4 "}
                                     onClick={
                                         () => {setPayType(20)}
                                     }
                                >
                                    <span className='fw-bold'>پرداخت نقدی</span>
                                    <p className='text-small-2 pt-2'>
                                        مبلغ درخواست را به صورت نقدی  پرداخت کنید
                                    </p>
                                </div>
                            </div>

                            <div className="col-12">
                                <button className='btn btn-success w-100 mt-3'
                                        onClick={onPayClick}

                                        disabled={payType === 0}
                                >
                                    پرداخت
                                    &nbsp;
                                    {
                                        payType === 21 && 'آنلاین'
                                    }
                                    {
                                        payType === 20 && 'نقدی'
                                    }
                                </button>
                            </div>
                        </div>
                    }


                </section>
            }


        </React.Fragment>
    );
}

export default Request;